import React, { useCallback, useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { toast } from 'react-toastify';

import * as Yup from 'yup';
import PropTypes from 'prop-types';
import { isArray } from 'lodash';

import { Spinner } from '~/components';
import { Input } from '~/components/Form';
import { updateNozzle, updateData } from '~/store/modules/vazaoPosto/actions';
import { closeDialog } from '~/store/modules/dialog/actions';
import { t } from '~/helpers';

import * as S from './styles';
import Table from '../Tabela';

export default function Form({ reference }) {
  const { loading, find } = useSelector((state) => state.vazaoPosto);

  const dispatch = useDispatch();

  const header = useMemo(
    () => [
      { id: 'bico_cod_bico', label: 'Bico', align: 'center' },
      {
        id: 'pobi_vazao_maxima',
        label: 'Vazão Máxima (L/min)',
        rule: () => true,
        callback: (value, key) => dispatch(updateNozzle(value, key)),
      },
    ],
    []
  );

  const handleSubmit = useCallback(
    async (data) => {
      try {
        const { bicos } = find;
        const schema = Yup.object().shape({
          pova_vazao_maxima: Yup.number()
            .typeError('Campo obrigatório.')
            .required('Campo obrigatório.')
            .min(0, 'Valor deve ser igual ou superior a 0'),
        });

        await schema.validate(data, {
          abortEarly: false,
        });

        await bicos.forEach((bico) => {
          const v = parseInt(bico.pobi_vazao_maxima);
          const e = `O bico ${bico.bico_cod_bico} deve conter um valor igual ou superior a 0.`;

          if (!bico.pobi_vazao_maxima || Boolean(v < 0)) throw Error(e);
        });

        const formData = {
          ...find,
          ...data,
          bicos,
        };

        dispatch(updateData(formData));
        dispatch(closeDialog());
      } catch (err) {
        const validationErrors = {};

        if (err instanceof Yup.ValidationError) {
          err.inner.forEach((error) => {
            validationErrors[error.path] = error.message.replace(
              `${error.path} `,
              ''
            );
          });

          reference.current.setErrors(validationErrors);
        } else {
          if (err.message) toast.error(err.message);

          if (isArray(err)) err.map((e) => toast.error(t(e)));
          else toast.error(t(err));
        }
      }
    },
    [find.bicos, reference]
  );

  if (loading)
    return (
      <div style={{ height: '14rem', width: '50rem' }}>
        <Spinner loading />
      </div>
    );

  return (
    <S.Wrapper ref={reference} initialData={find} onSubmit={handleSubmit}>
      <Input disabled name="post_cod_posto" label="Posto" />

      <Input
        name="pova_vazao_maxima"
        label="Vazão Máxima (L/min)"
        type="number"
      />

      <Table
        size="small"
        title="Encerrante dos Bicos"
        cells={header}
        data={find.bicos}
      />
    </S.Wrapper>
  );
}

Form.propTypes = {
  reference: PropTypes.objectOf(PropTypes.any).isRequired,
};
